 
import Chatframe from './Chatframe'


export default Chatframe;
export var CHAT_TYPE={
    TEXT:1,
    VOICE:2,
    IMG:3,
    FILE:4,
    LINK:5,
    VIDEO:6
}
export var CHAT_ROLE={
    ROBOT:1,
    USER:2
}


// WEBPACK FOOTER //
// ./src/myComponents/Chatframe/index.js